import type { ProvenanceActor } from "@product/components/app/runs/provenance-avatar-stack";
import type { ComposerSource } from "@product/components/app/sessions/composer-sources-view";
import type { WorkspaceChannel, WorkspaceSession } from "@product/lib/mlx-workspace-client";

import {
  ACTIVE_SESSION_ID,
  CHANNELS,
  COMPOSER_SOURCES,
  NOW,
  ORGANISATION,
  PINNED_SESSIONS,
  SESSIONS,
  SESSION_TITLE,
  UNREAD_SESSION_IDS,
  USER,
} from "./fixture";

/**
 * The workspace a shot frames: the organisation and person signed in, what
 * the rail lists, the session open in the pane and the sources its composer
 * can use. The landing concepts frame Ostrey Home; a solution page frames its
 * sector's demo organisation (solutions/sector-workspace.ts).
 */
export type ShotWorkspace = {
  organisationName: string;
  user: ProvenanceActor;
  /** The owner every rail row names, as the navigation store resolves it. */
  ownerId: string;
  channels: WorkspaceChannel[];
  sessions: WorkspaceSession[];
  pinnedSessions: WorkspaceSession[];
  unreadSessionIds: readonly string[];
  activeSessionId: string;
  sessionTitle: string;
  composerSources: readonly ComposerSource[];
};

/** A finished turn's times, as the transcript prints them (formatDateTime,
 *  formatElapsedAgo), fixed so every render of the shot reads the same. */
export type ShotTurnTimes = {
  askedAt: number;
  dateTitle: string;
  timeLabel: string;
};

/** The kettle question: asked a minute before the shot's "now". */
export const OSTREY_TURN_TIMES: ShotTurnTimes = {
  askedAt: NOW - 60_000,
  dateTitle: "17 Sept 2026, 14:01",
  timeLabel: "1 min ago",
};

export const OSTREY_WORKSPACE: ShotWorkspace = {
  organisationName: ORGANISATION.name,
  user: USER,
  ownerId: "usr_nadia",
  channels: CHANNELS,
  sessions: SESSIONS,
  pinnedSessions: PINNED_SESSIONS,
  unreadSessionIds: UNREAD_SESSION_IDS,
  activeSessionId: ACTIVE_SESSION_ID,
  sessionTitle: SESSION_TITLE,
  composerSources: COMPOSER_SOURCES,
};
